// extracted by mini-css-extract-plugin
export default {"ratingBar":"RatingCmp_ratingBar__xwGme"};